module.exports = __webpack_public_path__ + "static/img/listen.12b62f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/listen.png
// module id = edtw
// module chunks = 1